import React from "react";
import * as Yup from "yup";
import {
  DatePicker,
  Form,
  Row,
  Col,
  TextBox,
  Button,
  Panel,
  Checkbox,
  Select,
} from "@countysuite/ui";
import { getInputValueByName } from "utils/getInputValueByName";
import {
  LackOfProsecutionTemplate,
  LackOfProsecutionEditDefinitionViewModel,
  DispositionCategoryType,
} from "../LackOfProsecutionTypes";

export type Props = LackOfProsecutionEditDefinitionViewModel & {
  updateViewModel: (newState: any) => void;
  updateLopCategory: (selectedCategory: LackOfProsecutionTemplate) => void;
  onSave: () => Promise<boolean>;
  nextStep: () => void;
  lopTemplates: LackOfProsecutionTemplate[];
};

type State = {};

export class LackOfProsecutionEditDefinitionPanel extends React.Component<
  Props,
  State
> {
  handleNamedInputChange = (changeEvent: any) => {
    const newStateObject = getInputValueByName(changeEvent);
    this.props.updateViewModel(newStateObject);
  };

  changeLopTemplate = (e: any) => {
    let id = e.target.value;
    if (id) {
      id = Number(id);
      const selected = this.props.lopTemplates.find((cat) => cat.id === id);
      if (selected) {
        this.props.updateLopCategory(selected);
      }
    }
  };

  handleSubmit = async () => {
    const success = await this.props.onSave();
    if (success) {
      this.props.nextStep();
    }
  };

  formSchema = Yup.object().shape({
    description: Yup.string().required("The description is required."),
    lopTemplateID: Yup.number().min(
      1,
      "Please choose a lack of prosecution template."
    ),
    dispositionCategoryID: Yup.number().min(
      1,
      "Please choose an AOPC disposition category ID."
    ),
    referenceDate: Yup.object()
      .nullable()
      .required("Please choose a reference date."),
  });

  render() {
    return (
      <Form
        onSubmit={this.handleSubmit}
        values={this.props}
        validationSchema={this.formSchema}
      >
        {({ handleSubmit }) => (
          <Panel
            title="Definition"
            buttons={
              <>
                <Button color="success" onClick={handleSubmit}>
                  Save
                </Button>
              </>
            }
          >
            <Row>
              <Col md={6} xs={12}>
                <TextBox
                  label="Description"
                  name="description"
                  placeholder="Enter a description"
                  onChange={this.handleNamedInputChange}
                  value={this.props.description}
                />
                <TextBox
                  label="Notes"
                  name="notes"
                  multiline
                  rows={6}
                  placeholder="Optional notes for this Lack of Prosecution"
                  onChange={this.handleNamedInputChange}
                  value={this.props.notes}
                />
              </Col>
              <Col md={6} xs={12}>
                <Select
                  label="Lack of Prosecution Templates"
                  onChange={this.changeLopTemplate}
                  name="lopTemplateID"
                  value={this.props.lopTemplateID}
                  options={this.props.lopTemplates}
                />
                <DatePicker
                  label="Case Inactivity Since Date"
                  id="referenceDateId"
                  date={this.props.referenceDate}
                  placeholder="Reference date"
                  onDateChange={(date) =>
                    this.props.updateViewModel({ referenceDate: date })
                  }
                />
              </Col>
            </Row>
          </Panel>
        )}
      </Form>
    );
  }
}

(LackOfProsecutionEditDefinitionPanel as any).displayName =
  "LackOfProsecutionEditDefinitionPanel";
